import { message } from 'antd/lib/index'
import CSVTOJSON from 'csvtojson'
import { isEmpty, omit, pick } from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { compose } from 'recompose'
import TransactionsApi from '../../../../api/Finance/Transactions'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { dateVal, sessionItem, strVal } from '../../../../modules/Utils'
import Transactions from './Transactions'
import { checkForm as _checkForm } from '../../../../modules/Utils'

class TransactionsCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selection: [],
      selectAll: false,
      allocating: false,
      list: [],
      cached: [],
      transaction: {},
      statement: !!props.statement ? props.statement : {},
      fetching: false,
      visible: false,
      visibleAllocate: false,
      submitting: false,
      transactionUploadList: [],
    }
  }

  api = new TransactionsApi()
  formRef = React.createRef()
  formMapRef = React.createRef()
  formAllocateRef = React.createRef()
  tableRef = React.createRef()
  transactionUploadFormRef = React.createRef()

  fileReader = new FileReader()

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const { statement } = this.state
      let cached = !isEmpty(statement) ? await this.api.statementList(statement._id) : await this.api.list()

      let list = cached
      if (!isEmpty(this.state.company)) list = cached.filter((i) => i.company._id === this.state.company)

      this.setState({
        fetching: false,
        list,
        cached,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  fetchTransaction = async (key) => {
    try {
      this.setState({
        visible: true,
        type: 'edit',
        fetchingTransaction: true,
      })
      const transaction = await this.api.read(key)
      this.setState({
        fetchingTransaction: false,
        transaction,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetchingTransaction: false, visible: false })
    }
  }
  onShow = () => {
    this.setState({
      visible: true,
      transaction: {},
      type: 'new',
    })
  }
  onShowMap = () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (!selection.reduce((prv, current) => (strVal(prv, 'bank._id') === strVal(current, 'bank._id') ? prv : NaN))) {
      message.error('Not the same bank')
      return
    }
    const bank = strVal(selection, '0.bank._id')
    const url = `statements/?select=*&status=Submitted` + (isEmpty(bank) ? '' : `&bank=${bank}`)
    sessionStorage.removeItem(`statements_${url}_dropdown`)
    const StatementSelectCmp = compose(
      withUrlFetch({
        name: 'statements',
        url: url,
        cache: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.setState({
      visibleMap: true,
      bank,
      StatementSelectCmp,
      url,
      company: strVal(selection, '0.company._id'),
    })
  }
  onShowAllocate = () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (selection.filter((s) => s.allocated === true).length > 0) {
      message.error('Some transactions already allocated')
      return
    }
    const TransactionsSelectCmp = compose(
      withData({
        data: this.state.list.filter((t) => selection.map((s) => s._id).indexOf(t._id)),
      }),
      withSort
    )(CustomSelect)
    this.setState({
      visibleAllocate: true,
      TransactionsSelectCmp,
    })
  }
  onCancel = () => {
    this.formRef.current && this.formRef.current.resetFields()
    this.setState({
      visible: false,
      transaction: {},
    })
  }
  onCancelMap = () => {
    this.formMapRef.current.resetFields()
    this.setState({
      visibleMap: false,
      bank: '',
      company: '',
      statement: {},
    })
  }
  onCancelAllocate = () => {
    this.setState({
      visibleAllocate: false,
      transactionSelected: {},
    })
  }
  submit = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      await this.api.create(this.state.transaction)
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  update = async () => {
    await this.checkForm()
    try {
      let { transaction } = this.state
      this.setState({
        submitting: true,
      })
      await this.api.update(omit(transaction, ['company', 'status', '_history', 'allocated']))
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          console.log({ values })
          this.setState({
            transaction: Object.assign(
              {},
              pick(this.state.transaction, ['_id', '_rev', '_key', 'company', 'status', '_history', 'allocated']),
              values
            ),
          })
          res(true)
        }
      })
    })
  }
  checkAllocateForm = () => {
    return new Promise((res, rej) => {
      this.formAllocateRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(true)
        }
      })
    })
  }
  onEdit = async (e, transaction) => {
    await this.fetchTransaction(transaction._key)
  }
  remove = async () => {
    try {
      this.setState({
        removing: true,
      })
      const { transaction } = this.state
      await this.api.remove(pick(transaction, ['_id', '_key', '_rev']))
      this.setState({
        removing: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ removing: false })
    }
  }
  map = async () => {
    try {
      this.setState({
        mapping: true,
      })
      const selection = this.state.selection
      const statement = this.state.statement
      await this.api.map({
        statement: pick(statement, ['_id', '_key', '_rev']),
        transactions: selection,
      })
      this.setState({
        mapping: false,
      })
      this.onCancelMap()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ mapping: false })
    }
  }

  allocateRemi = async () => {
    const data = await _checkForm(this.formAllocateRef)
    console.log(321, { data })
    try {
      let { transaction } = this.state
      this.setState({
        allocating: true,
      })

      await this.api.update({
        ...omit(transaction, ['company', 'status', '_history', 'allocated']),
        ...data,
        allocated: true,
      })
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ allocating: false })
    }
  }

  allocate = async (selection, type) => {
    await this.checkAllocateForm()
    if (isEmpty(selection) && type !== 'bank-fee') {
      message.info('select a remittance')
      return
    }
    try {
      this.setState({
        allocating: true,
      })
      const allocation = selection[0]
      const transaction = this.state.transaction
      await this.api.allocate({
        transaction: pick(transaction, ['_id', '_key', '_rev']),
        allocation: { _id: allocation },
        debit: { purpose: type },
      })
      this.setState({
        allocating: false,
      })
      await this.fetchTransaction(this.state.transaction._key)
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ allocating: false })
    }
  }
  unallocate = async () => {
    try {
      this.setState({
        allocating: true,
      })

      const transaction = this.state.transaction
      await this.api.unallocate(pick(transaction, ['_id', '_key', '_rev']))
      this.setState({
        allocating: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ allocating: false })
    }
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }
  onChangeStatement = (statementID) => {
    let sessionID = `statements_${this.state.url}_dropdown`
    const statement = sessionItem(sessionID, statementID, '_id')
    statement.date = dateVal(statement, 'date')
    statement.period = [dateVal(statement, 'period.start'), dateVal(statement, 'period.end')]
    this.setState({
      statement,
    })
  }
  onChangeTransaction = (transactionID) => {
    this.setState((prvState) => ({
      transactionSelected: prvState.list.find((t) => t._id === transactionID),
    }))
  }
  onShowStatement = (statement) => {
    statement.date = dateVal(statement, 'date')
    statement.period = [dateVal(statement, 'period.start'), dateVal(statement, 'period.end')]
    this.setState({
      statement,
      visibleStatement: true,
    })
  }
  onCancelStatement = () => {
    this.setState({
      visibleStatement: false,
      statement: {},
    })
  }
  filterCompany = (_id) => {
    this.setState((prevState, props) => ({
      list: _id ? prevState.cached.filter((i) => i.company._id === _id) : prevState.cached,
    }))
  }
  onChangeCompany = (company) => {
    this.filterCompany(company)
    this.setState({
      company,
    })
  }
  allocateBank = async () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (selection.filter((s) => s.allocated === true).length > 0) {
      message.error('Some transactions already allocated')
      return
    }
    try {
      this.setState({
        fetching: true,
      })
      await this.api.allocateBank({ transactions: this.state.selection })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }

  onTransactionUpload = async () => {
    const values = await this.checkTransactionUploadForm()
    let transactionUploadList = [...this.state.transactionUploadList]
    transactionUploadList = transactionUploadList.map((transaction) => {
      const d = {
        amount: parseFloat(transaction['Debit'] || transaction['Credit']),
        bank: values.bank,
        company: values.company,
        type: transaction['Credit'] ? 'credit' : 'debit',
        date: moment(transaction['Date'], 'DD/M/YY').format(),
        notes: transaction['Description'],
        balance: parseFloat(transaction['Balance']),
        remittance: { ref: 'CSV Uploaded' },
      }
      return {
        ...d,
      }
    })
    try {
      this.setState({
        uploadingCSV: true,
      })
      await this.api.uploadCSV(transactionUploadList)
      this.setState({
        uploadingCSV: false,
      })
      this.onCancelTransactionUpload()
      this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        uploadingCSV: false,
      })
    }
  }
  checkTransactionUploadForm = () => {
    return new Promise((res, rej) => {
      this.transactionUploadFormRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  onShowTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: true,
    })
  }
  onCancelTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: false,
      transactionUploadList: [],
      csvFileList: [],
    })
  }
  onFileLoadEnd = async () => {
    try {
      const content = this.fileReader.result
      const transactionUploadList = await CSVTOJSON().fromString(content)
      this.setState({
        transactionUploadList,
      })
    } catch (e) {
      message.error(e.errorMessage)
    }
  }
  onFileLoaded = async ({ file }) => {
    try {
      this.fileReader.onloadend = this.onFileLoadEnd
      if (file) {
        await this.fileReader.readAsText(file)
      }
    } catch (e) {
      message.error('Error Reading the file.')
    }
  }
  beforeUpload = (file) => {
    this.setState({
      csvFileList: [file],
    })
    return false
  }

  render() {
    return (
      <Transactions
        {...this.state}
        {...pick(this, [
          'fetch',
          'onCancel',
          'onCancelMap',
          'onCancelAllocate',
          'onCancelStatement',
          'onCancelTransactionUpload',
          'onShow',
          'onShowStatement',
          'onShowAllocate',
          'onShowMap',
          'onShowTransactionUpload',
          'onEdit',
          'onTransactionUpload',
          'submit',
          'update',
          'remove',
          'map',
          'allocateRemi',
          'allocate',
          'unallocate',
          'allocateBank',
          'toggleSelection',
          'toggleAll',
          'isSelected',
          'onChangeStatement',
          'onChangeTransaction',
          'filterCompany',
          'onChangeCompany',
          'formRef',
          'formMapRef',
          'formAllocateRef',
          'tableRef',
          'transactionUploadFormRef',
          'onFileLoadEnd',
          'onFileLoaded',
          'beforeUpload',
        ])}
      />
    )
  }
}

TransactionsCont.propTypes = {}
TransactionsCont.defaultProps = {}

export default TransactionsCont
